var _a;
import { __spreadArrays } from "tslib";
import { Level } from "../Level";
var levelToMethodMapping = (_a = {},
    _a[Level.Emergency] = "error",
    _a[Level.Alert] = "error",
    _a[Level.Critical] = "error",
    _a[Level.Error] = "error",
    _a[Level.Warning] = "warn",
    _a[Level.Notice] = "warn",
    _a[Level.Info] = "info",
    _a[Level.Debug] = "log",
    _a);
/**
 * Console adapter
 */
var Console = /** @class */ (function () {
    function Console(config) {
        this.console = config.console;
        this.logPrefix = config.logPrefix || "";
    }
    Console.prototype.log = function (msgs, level) {
        var _a;
        if (this.console && level in levelToMethodMapping) {
            (_a = this.console)[levelToMethodMapping[level]].apply(_a, __spreadArrays([this.logPrefix], msgs));
            // DEBUG: add location
            // this.console[levelToMethodMapping[level]](
            //     `[HC]`,
            //     ...msgs,
            //     " @",
            //     Error()
            //         .stack.split(/\n/g)[4]
            //         .replace("webpack-internal:///", "")
            // );
            return true;
        }
        return false;
    };
    Console.prototype.resolveConsoleReference = function () { };
    return Console;
}());
export default Console;
//# sourceMappingURL=Console.js.map